import React from 'react';
import styled from 'styled-components';

import RevenueSummaryPane from '../../containers/revenue/RevenueSummaryPane';
import RevenueMainPane from '../../containers/revenue/RevenueMainPane';
import RevenuePaymentFilterModal from '../../containers/revenue/RevenuePaymentFilterModal';
import DocsLink from '../docs/DocsLink';
import docsBookmarks from '../../constants/docs';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const RevenueViewContainer = styled.div`
  height: calc(100% - 63px);
  overflow-y: auto;

  .main {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px;
    height: 100%;
  }

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
  }

  .title-text {
    margin: 0;
  }
`;

export const extraContentFnRevenue = () => (
  <div style={{ marginRight: 10 }}>
    <RevenuePaymentFilterModal />
  </div>
);

export const RevenueView = ({
  executing,
  onExecute,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar onExecute={onExecute} executeDisabled={executing} extraActions={extraActions}>
      <div style={{ marginRight: 10 }}>
        <RevenuePaymentFilterModal />
      </div>
    </NavigationBar>
    <RevenueViewContainer>
      <div className="main">
        <div className="title">
          <h2 className="title-text">Revenue</h2>
          <DocsLink
            scrolTo={docsBookmarks.revenue}
            styleIcon={{ fontSize: 20, margin: 5, color: 'gray' }}
          />
        </div>
        <RevenueSummaryPane />
        <SpinnerWithButton
          onClick={onRequestCancel}
          disabled={cancelButtonDisabled}
          executing={executing}
        >
          <RevenueMainPane />
        </SpinnerWithButton>
      </div>
    </RevenueViewContainer>
  </>
);
